import { getScrollTop, scrollTo, getScrollEventTarget, scrollContainerMediaQuery } from '@theme/scroll-container';
import { prefersReducedMotion } from '@theme/utilities';

const button = document.getElementById('ew-back-to-top');

if (button) {
  const SHOW_AFTER = window.innerHeight;

  let scrollTarget = getScrollEventTarget();
  let rafId = /** @type {number | null} */ (null);

  const updateVisibility = () => {
    rafId = null;
    button.classList.toggle('ew-back-to-top--visible', getScrollTop() > SHOW_AFTER);
  };

  function handleScroll() {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(updateVisibility);
  }

  function bindScrollTarget() {
    scrollTarget.removeEventListener('scroll', handleScroll);
    scrollTarget = getScrollEventTarget();
    scrollTarget.addEventListener('scroll', handleScroll, { passive: true });
  }

  scrollTarget.addEventListener('scroll', handleScroll, { passive: true });
  scrollContainerMediaQuery.addEventListener('change', bindScrollTarget);
  // EW CUSTOM: initial check in the next frame, no layout read during module init
  handleScroll();

  button.addEventListener('click', () => {
    scrollTo({ top: 0, behavior: prefersReducedMotion() ? 'instant' : 'smooth' });
  });

  const shopifyChat = document.querySelector('shopify-chat');
  if (shopifyChat) {
    const GAP = 20;
    const MAX_PLAUSIBLE_HEIGHT = 120;

    customElements.whenDefined('shopify-chat').then(() => {
      const activator = shopifyChat.shadowRoot?.querySelector('[part="activator"]');
      const launcher = activator?.closest('.activator-nudge') ?? activator;
      if (!launcher) return;

      new ResizeObserver(([entry]) => {
        if (!entry) return;
        const height = entry.contentRect.height;
        if (height <= 0 || height > MAX_PLAUSIBLE_HEIGHT) return;
        document.body.style.setProperty('--ew-chat-bubble-clearance', `${Math.round(height) + GAP}px`);
      }).observe(launcher);
    });
  }
}
